<script lang="ts">
    import { cn } from '$lib/utils/cn';

    import Image from './Image.View.svelte';

    export let mode: 'dark' | 'light';
    export let headline = '';
    export let subHeadline = '';
    export let image: string;
    export let fixedMaxWidth: number;
    export let isInMultiColumn = false;
</script>

<div
    class={cn('fun-relative fun-w-full', {
        'fun-bg-black': mode === 'dark',
        'fun-bg-white': mode === 'light',
    })}
>
    <div
        style="transform: translate3d(0,0,3px)"
        class:fun-text-white={mode === 'dark'}
        class:fun-text-black={mode === 'light'}
        class={cn(
            'fun-absolute fun-inset-x-0 fun-bottom-8 fun-z-20 fun-flex fun-w-full fun-flex-col fun-items-center fun-px-7 fun-text-center',
            {
                'md:fun-top-0 md:fun-w-[60%] md:fun-items-start md:fun-justify-center md:fun-text-left':
                    !isInMultiColumn,
            },
        )}
    >
        <p
            class={cn('fun-mb-5 fun-text-base fun-font-semibold', {
                'md:fun-text-2xl': !isInMultiColumn,
                'lg:fun-text-4xl': headline.length <= 150 && !isInMultiColumn,
                'lg:fun-text-2xl': headline.length > 150 && !isInMultiColumn,
            })}
        >
            {headline}
        </p>
        <p class={cn('fun-text-sm fun-font-semibold', { 'md:fun-text-lg': !isInMultiColumn })}>
            {subHeadline}
        </p>
    </div>
    <div
        style="transform: translate3d(0,0,2px)"
        class={cn('fun-absolute fun-inset-0 fun-z-10 fun-h-full fun-w-full', {
            'fun-bg-gradient-to-t fun-from-black fun-to-black/0': mode === 'dark',
            'fun-bg-gradient-to-t fun-from-white fun-to-white/0': mode === 'light',
            'md:fun-hidden': !isInMultiColumn,
        })}
    />
    <div class={cn('fun-relative fun-ml-auto', { 'md:fun-max-w-md': !isInMultiColumn })}>
        <div
            style="transform: translate3d(0,0,2px)"
            class={cn(
                'fun-absolute fun--left-1 fun-bottom-0 fun-top-0 fun-z-10 fun-hidden fun-h-full fun-w-[60%] fun-bg-gradient-to-r',
                {
                    'fun-from-black fun-to-black/0': mode === 'dark',
                    'fun-from-white fun-to-white/0': mode === 'light',
                    'md:fun-block': !isInMultiColumn,
                },
            )}
        />
        <div style="transform: translate3d(0,0,1px)">
            <Image size="xLarge" src={image} {fixedMaxWidth} />
        </div>
    </div>
</div>
